import * as React from 'react';
import { withIntl, IntlProps } from 'ha/i18n';
import { Typography, Align } from 'ha/ui/next/Typography';

interface Props {
  className?: string;
  align?: Align;
}

export const RoomsTitle: React.SFC<Props & IntlProps> = ({
  className,
  align,
  intl: { T },
}) => (
  <Typography.H2 component="h2" align={align} className={className}>
    {T('Featured private rooms for rent')}
  </Typography.H2>
);

export default withIntl(RoomsTitle);
